import React from 'react';

import {connect, Provider} from 'react-redux';

import { createBrowserRouter, Router } from 'react-router';
import { ErrorBoundary } from "react-error-boundary";

import {IntlProvider} from 'react-intl';

import {withDefaultLayout} from 'dcx/app/components/Layouts';

import {Route, Routes, RouterProvider, createBrowserRouter,Link, Outlet} from 'react-router';

export const makeNextAuthenticationServerConfiguration = (applicationName) => {

    const publicRoutes = [];

    const defaultAppConfiguration = {
        application: {
            name: applicationName,
            protectedRoutes: []
        }
    }

    const protectedRoutes = []

    const dashboardRoutes = []

    const nextConfiguration = Object.assign(defaultAppConfiguration, {
        'token-key': '_xnext',
        signinRedirectRoute: '/',
        application: Object.assign(defaultAppConfiguration.application, {
            publicRoutes,
            protectedRoutes,
            dashboardRoutes
        })
    });
    return nextConfiguration;
}
let globalConfiguration = makeNextAuthenticationServerConfiguration('NEXT AUTHENTICATION SERVER');

import NextSignInContainer from './containers/NextSignInContainer'
import SignOutContainer from './containers/SignOutContainer';

const NextSignInContainerWithLayout = NextSignInContainer
const SignOutContainerWithLayout = withDefaultLayout(SignOutContainer)

const GlobalError = () => (<>OOPS</>);

const ErrorBoundaryLayout = () => (
  <ErrorBoundary FallbackComponent={GlobalError}>
     <Outlet />
  </ErrorBoundary>)

import CssBaseline from '@mui/material/CssBaseline';


const makeRouter = (theme,dialogsHandlers,dialogsFocus) => createBrowserRouter([{
    element: (<ErrorBoundaryLayout />),
    children: [{
        path: "*",
        element: (
            <Routes>
                <Route
                    key={`route-/`}
                    path={'/'}
                    element={<NextSignInContainerWithLayout theme={theme} globalConfiguration={globalConfiguration}/>}
                  />
                  <Route
                      key={`route-/next-signin`}
                      path='/next-signin'
                      element={<NextSignInContainerWithLayout theme={theme} globalConfiguration={globalConfiguration}/>}
                  />
                  <Route
                      key={`route-/signout`}
                      path='/signout'
                      element={<SignOutContainerWithLayout theme={theme} globalConfiguration={globalConfiguration}/>}
                  />
            </Routes>
        )
      }
    ],
  }
]);

export const NextAuthenticationServer = ({theme,store}) => {
    if(!theme){
        return (<>no theme</>)
    }
    const dialogsHandlers = {}
    const dialogsFocus = {}
    return (
         <>
             <CssBaseline/>

             <IntlProvider
                locale={'en'}
                messages={{}}>
                <Provider store={store}>
                   <RouterProvider router={makeRouter(theme,dialogsHandlers,dialogsFocus)} />
                </Provider>
            </IntlProvider>
        </>
    )
}